module.exports = __webpack_public_path__ + "img/sparking-change-spotlight.19702003.png";